import SplunkOtelWeb from '@splunk/otel-web';
import { AppSettings } from './configs';

 console.log("splunk_env" , `${AppSettings.splunk_env}`);
 console.log("app" , `do62003-rss-web-app-${AppSettings.splunk_env}`);

SplunkOtelWeb.init({
   beaconUrl: "https://rum-ingest.us1.signalfx.com/v1/rum",
   rumAuth: "MYoVLri_s0GwvT9UbDCAQw",
   app: `do62003-rss-web-app-${AppSettings.splunk_env}`,
   environment: `${AppSettings.splunk_env}`
});

